// extracted by mini-css-extract-plugin
export default {"section5Wrapper":"Section5_section5Wrapper__j5QdO","partnerItem":"Section5_partnerItem__NqrNM","partnerLogo":"Section5_partnerLogo__99dnq"};